"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCNative_1 = __importDefault(require("./VoxeetRTCNative"));
const debug_1 = __importDefault(require("debug"));
const Exceptions_1 = require("../Exceptions");
const VoxeetRTCShim_1 = require("./VoxeetRTCShim");
const WebRtcUtils_1 = require("../WebRtcUtils");
const config_1 = __importDefault(require("../../config/config"));
const bowser_1 = __importDefault(require("bowser"));
const logging_1 = __importDefault(require("../../lib/logging"));
const MediaStream_1 = require("../../models/MediaStream");
const DvcAudio_js_1 = __importDefault(require("../DvcAudio.js"));
/**
 * @ignore
 */
const debug = debug_1.default('vxt:rtc:dvwc');
//debug.enabled = true;
/**
 * @ignore
 */
const browser = bowser_1.default.getParser(window.navigator.userAgent);
/**
 * @ignore
 */
const DolbyVoiceError = (msg) => new Exceptions_1.ConferenceError('DolbyVoiceError', msg);
class WorkerAsyncCall {
    constructor(worker) {
        this.worker = worker;
        this.requests = {};
    }
    request(name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.requests[name]) {
                this.requests[name] = [];
            }
            return new Promise((resolve, reject) => {
                let requestList = this.requests[name];
                requestList.push({ resolve: resolve, reject: reject });
                this.worker.postMessage({ type: name + '-request', data });
            });
        });
    }
    handleResponse(name, message) {
        if (this.requests[name]) {
            const request = this.requests[name].shift();
            if (request) {
                if (message.error) {
                    request.reject(DolbyVoiceError(message.error));
                }
                else {
                    request.resolve(message.result);
                }
            }
        }
    }
}
class VoxeetRTCDolbyVoice extends VoxeetRTCNative_1.default {
    constructor(options = {}) {
        super(options);
        this.worker = null;
        this.workerAsyncCall = null;
        this.audioChannel = null;
        this.initResolve = null;
        this.initReject = null;
        this.audio = null;
        this.dvcAudioMuted = false;
        this.haveSession = false;
        this.stateDumpResolve = null;
        this.stateDumpReject = null;
        this.pendingLevelCallbacks = null;
        this.cachedLevels = null;
        this.stopSessionResolve = null;
        this.stopSessionReject = null;
        this.onConnectionStatus = null;
    }
    //TODO: Implement WASM specific mute
    onTrackMuted(peerId, peer, stream, e) {
        debug('onTrackMuted', e);
        if (peer.stream) {
            if (stream && stream.getTracks().filter((t) => !t.muted).length > 0) {
                const media = new MediaStream([...stream.getTracks().filter((t) => !t.muted)]);
                media.type = stream.type;
                //media.id = stream.id;
                this.updateStreamEvent(peerId, media);
            }
            else {
                this.removeStreamEvent(peerId, peer.stream);
                peer.stream = null;
            }
        }
    }
    //TODO: Implement WASM specific mute
    onTrackUnMuted(peerId, peer, stream, e) {
        debug('onTrackUnMuted', e);
        if (e.target.kind === 'audio') {
            const pos = this.getPeerPosition(peerId);
            if (peer.process) {
                peer.process.disconnect();
            }
            this.setPeerPosition(peerId, pos.x, pos.y);
        }
        if (peer.stream) {
            //already received a stream for this peer
            const media = new MediaStream([...stream.getTracks().filter((t) => !t.muted), e.target]);
            media.type = stream.type;
            //media.id = stream.id;
            this.updateStreamEvent(peerId, peer.stream);
        }
        else {
            peer.stream = stream;
            this.addStreamEvent(peerId, stream);
        }
    }
    stopSession() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.haveSession) {
                let stopSessionPromise = new Promise((resolve, reject) => {
                    this.stopSessionReject = reject;
                    this.stopSessionResolve = resolve;
                });
                this.worker.postMessage({ type: 'leave' });
                return stopSessionPromise;
            }
        });
    }
    resolveStopSession() {
        this.haveSession = false;
        if (this.stopSessionResolve) {
            this.stopSessionResolve();
            this.stopSessionResolve = null;
            this.stopSessionReject = null;
        }
        else {
            this.handleUnexpectedLeave();
        }
    }
    rejectStopSession(message) {
        this.haveSession = false;
        if (this.stopSessionReject) {
            this.stopSessionReject(DolbyVoiceError(message));
            this.stopSessionResolve = null;
            this.stopSessionReject = null;
        }
        else {
            this.onSessionStopped();
        }
    }
    release() {
        const _super = Object.create(null, {
            release: { get: () => super.release }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.stopSession();
            yield this.onSessionStopped();
            yield _super.release.call(this);
        });
    }
    onSessionStopped() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.audio) {
                this.audio.stopInputAudio();
                this.audio.stopOutputAudio();
                this.audio = null;
            }
            if (this.worker) {
                yield this.workerAsyncCall.request('release');
                this.worker.terminate();
            }
            this.stopDataFlow();
        });
    }
    handleUnexpectedLeave() {
        return __awaiter(this, void 0, void 0, function* () {
            let liteMode = true;
            let stateDump = yield this.createStateDump(liteMode);
            this.emit('sessionEnded', stateDump);
            this.release();
        });
    }
    addPeer({ peerId, description, candidates, wasmDescription, wasmCandidates, isMaster, state = 'default' }) {
        const _super = Object.create(null, {
            addPeer: { get: () => super.addPeer }
        });
        return __awaiter(this, void 0, void 0, function* () {
            // Remove audio codecs before setting up
            // When we fail to setup DolbyVoice we can fallback to Opus codec
            // without asking again for SDP
            let new_description = description;
            if (new_description) {
                let audio_media = false;
                let lines = new_description.sdp.split('\n').map((l) => l.trim()); // split and remove trailing CR
                lines.forEach((line, index, array) => {
                    if (line.startsWith('m=audio')) {
                        audio_media = true;
                        array[index] = null;
                    }
                    else if (line.startsWith('m=')) {
                        audio_media = false;
                    }
                    else if (audio_media) {
                        array[index] = null;
                    }
                    else if (line.startsWith('a=group:BUNDLE') !== -1) {
                        array[index] = line.replace('audio ', '');
                    }
                });
                // Remove empty lines
                lines = lines.filter((el) => {
                    return el != null;
                });
                new_description.sdp = lines.join('\r\n');
            }
            let new_candidates = candidates;
            if (new_candidates) {
                // replace audio with video as we are using bundle-max
                new_candidates.forEach((el, index, array) => {
                    if (el.mid === 'audio') {
                        array[index].mid = 'video';
                    }
                });
            }
            try {
                if (new_description) {
                    yield _super.addPeer.call(this, { peerId, description: new_description, candidates: new_candidates, isMaster, state });
                    if (wasmDescription) {
                        yield this.addPeerWasm({ peerId, description: wasmDescription, candidates: wasmCandidates, state });
                    }
                }
            }
            catch (err) {
                logging_1.default.error('webrtc', 'VoxeetRTCDolbyVoice.addPeer error: ', peerId, err);
                throw err;
            }
        });
    }
    addPeerWasm({ peerId, description, candidates, state }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.createPeerConnectionWasm(peerId);
            // We should add only Audio on correct connection.
            yield this.setRemoteDescriptionWasm(peerId, this.getSsrc(description.sdp), description.type, description.sdp);
            yield Promise.all(candidates.map((c) => __awaiter(this, void 0, void 0, function* () {
                if (!browser.msedge) {
                    yield this.setPeerCandidateWasm(peerId, c.mid, c.mline_index, c.sdp);
                }
            })));
            yield this.createAnswerWasm(peerId, state, description.oid); // No need to wait for ice candidates gathering
        });
    }
    createPeerConnectionWasm(peerId) {
        return __awaiter(this, void 0, void 0, function* () {
            let audioConnection;
            let peer;
            this.peers
                .filter((c) => c.peerId === peerId)
                .map((p) => {
                peer = p;
                audioConnection = p.audioConnection;
            });
            if (audioConnection) {
                audioConnection.candidates = new Array();
            }
            else {
                // TODO: remove this recurrence VoxeetRTC.sdpSemantics();
                let configuration = config_1.default.peerConnection.config;
                configuration.sdpSemantics = 'unified-plan';
                // We are not going to use bundlePolicy for datachannel as we have only one stream.
                delete configuration.bundlePolicy;
                audioConnection = new VoxeetRTCShim_1.RTCPeerConnection(configuration, config_1.default.peerConnection.constraints);
                audioConnection.candidates = new Array();
                // TODO: Check if we need this events?
                // await this.addConnectionListeners(peer);
                // await this.addTrackListeners(peerId, peer, { x: 0, y: 0.2 }, connection);
                audioConnection.onicecandidate = (evt) => {
                    if (!evt.candidate) {
                        //Ice Gathering complete
                        this.iceCandidatesGatheringCompleteEvent(peerId, audioConnection.candidates);
                    }
                    else {
                        //TODO: check if sdp non empty
                        audioConnection.candidates.push({
                            sdpMid: evt.candidate.sdpMid,
                            sdpMLineIndex: evt.candidate.sdpMLineIndex,
                            sdp: evt.candidate.candidate,
                        });
                    }
                };
                debug('createPeerConnection', peerId, ' for Data Channel');
                peer.audioConnection = audioConnection;
                // Create dataChannel for audioConnection.
                if (this.worker && !this.haveSession) {
                    this.dataChannel = peer.audioConnection.createDataChannel('DVC', { maxRetransmits: 0, negotiated: false, ordered: false, id: 0 });
                    this.dataChannel.binaryType = 'arraybuffer';
                    this.addDataChannelListeners(this.dataChannel, peerId);
                    this.addConnectionListeners(peerId);
                }
                else {
                    debug('createPeerConnection', 'Failed to create datachannel for peer ', peerId, ' for Data Channel');
                }
            }
        });
    }
    setPeerCandidateWasm(peerId, sdpMid, sdpMLineIndex, sdp) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                yield c.audioConnection.addIceCandidate(new VoxeetRTCShim_1.RTCIceCandidate({
                    candidate: sdp,
                    sdpMLineIndex: sdpMLineIndex,
                    sdpMid: sdpMid,
                }));
            })));
        });
    }
    setRemoteDescriptionWasm(peerId, ssrc, type, sdp, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            debug('setRemoteDescriptionWasm');
            debug('Offer', sdp);
            yield Promise.all(this.peers
                .filter((peer) => peer.peerId === peerId)
                .map((peer) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield peer.audioConnection.setRemoteDescription(new VoxeetRTCShim_1.RTCSessionDescription({ type: type, sdp: sdp }));
                }
                catch (err) {
                    logging_1.default.error('webrtc', 'VoxeetRTCDolbyVoice.setRemoteDescriptionWasm error: ', peerId, err);
                    throw RemoteDescriptionError(err, peer.peerId);
                }
            })));
        });
    }
    createAnswerWasm(peerId, state = 'default', oid) {
        return __awaiter(this, void 0, void 0, function* () {
            debug('createAnswerWasm', peerId, oid);
            const peer = this.peers.find((c) => c.peerId === peerId);
            if (!peer) {
                throw PeerNotFoundError(peerId);
            }
            try {
                const answer = yield peer.audioConnection.createAnswer();
                debug('Answer', answer.sdp);
                yield peer.audioConnection.setLocalDescription(answer);
                this.sessionCreatedEvent(peerId, peer.audioConnection.localDescription, null, 'none', state, oid, { enabled: true });
            }
            catch (err) {
                logging_1.default.error('webrtc', 'VoxeetRTCDolbyVoice.createAnswerWasm', err);
                throw CreateAnswerError(err, peer.peerId);
            }
        });
    }
    //Overrides VoxeetRTCNative addMasterStream()
    addMasterStream(peer) {
        return __awaiter(this, void 0, void 0, function* () {
            debug('addMasterStream', peer);
            if (this.localMediaStream) {
                const isNew = !peer.stream;
                yield this.addStream(this.localMediaStream, peer.connection);
                peer.stream = this.localMediaStream;
                if (isNew) {
                    this.addStreamEvent(peer.peerId, this.localMediaStream);
                }
                else {
                    this.updateStreamEvent(peer.peerId, this.localMediaStream);
                }
            }
        });
    }
    // TODO: Review adding track listeners on WASM
    addTrackListeners(peerIdOld, peerOld, position, connection) {
        return __awaiter(this, void 0, void 0, function* () {
            connection.ontrack = (evt) => {
                //debug("ontrack", evt, evt.streams, evt.streams[0].getVideoTracks());
                let stream = evt.streams[0];
                if (stream) {
                    // Fix for msid not received after before adding the screenshare
                    let peerId = this.checkStream(stream);
                    let peer = this.peers.find((item) => item.peerId === peerId);
                    if (!peer) {
                        peer = {
                            peerId: peerId,
                            connection: null,
                            audioConnection: null,
                            stream: null,
                            process: null,
                            isMaster: false,
                        };
                        this.peers.push(peer);
                    }
                    peer.closed = false;
                    if (evt.streams[0].id.search('screen_') === -1) {
                        if (evt.streams[0].getAudioTracks().length > 0) {
                            evt.streams[0].getAudioTracks()[0].enabled = true;
                            // if (position && this.audioContext) {
                            //   peer.process.setPosition(position.x, position.y); // In case of renegociation
                            // }
                        }
                        //evt.streams[0].onaddtrack = e => this.onAddTrack(peerId, peer, e);
                        evt.streams[0].onremovetrack = (e) => this.onRemoveTrack(peerId, e);
                        if (!peer.stream) {
                            this.addStreamEvent(peerId, evt.streams[0]);
                        }
                        else {
                            this.updateStreamEvent(peerId, evt.streams[0]);
                        }
                        peer.stream = evt.streams[0];
                    }
                    else {
                        //Screensharing
                        evt.streams[0].onremovetrack = (e) => this.onScreenRemoveTrack(peerId, e);
                        // Workaround for Safari not firing onremovetrack for screenshare
                        if (browser.isBrowser('safari', true)) {
                            this.remoteScreenStream = evt.streams[0];
                            this.remoteScreenStream.type = MediaStream_1.MediaStreamType.ScreenShare;
                        }
                        setTimeout(() => {
                            this.addScreenStreamEvent(peerId, evt.streams[0]);
                        }, 1);
                    }
                }
            };
            connection.onremovestream = (evt) => {
                debug('onremovestream', evt);
                if (evt.stream.id.search('screen_') !== -1) {
                    //this.removeScreenStreamEvent();
                }
            };
        });
    }
    _startInputAudio(config) {
        this.worker.postMessage({ type: 'start-input-audio', inputAudioConfig: config });
        return this.audio.startInputAudio(this.localMediaStream);
    }
    init({ constraints, processCb, listenOnly, ownerId, options, dvwc }) {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this, { constraints, processCb, listenOnly, ownerId, options });
            yield this.initDvwc(dvwc, listenOnly, options);
        });
    }
    initDvwc(wasm, listenOnly, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (wasm && !this.worker) {
                try {
                    const loadPromise = new Promise((resolve, reject) => {
                        this.initResolve = resolve;
                        this.initReject = reject;
                    });
                    this.wasm = wasm;
                    this.worker = new Worker('voxeet-dvwc-worker.js');
                    this.workerAsyncCall = new WorkerAsyncCall(this.worker);
                    this.worker.onmessage = (e) => this.onWorkerMessage(e.data);
                    const audioChannel = new MessageChannel();
                    const defaultAudioTweaks = {
                        useSharedBuffer: false,
                        sharedBufferTimer: false,
                        outputQueueMs: 50,
                        crossFadeMs: 10,
                        rampMs: 50,
                    };
                    var ovverrideAudioTweaks = ((json) => {
                        if (json === null) {
                            return null;
                        }
                        try {
                            return JSON.parse(json);
                        }
                        catch (_a) {
                            debug('Incorrect audioTweaks override format - ignoring');
                            return null;
                        }
                    })(localStorage.getItem('audioTweaks'));
                    const audioTweaks = Object.assign(Object.assign(Object.assign({}, defaultAudioTweaks), ovverrideAudioTweaks), options.audioTweaks);
                    // Fix for situation where output queue of buffer regularly underflows
                    // because it's shorter  or similar length than the underlying browser buffer
                    const minQueueMs = this.audioContext.baseLatency * 1.5;
                    if (audioTweaks.outputQueueMs < minQueueMs) {
                        audioTweaks.outputQueueMs = minQueueMs;
                    }
                    this.audio = new DvcAudio_js_1.default(audioChannel.port1, this.audioContext, {
                        enableInput: Boolean(this.localMediaStream),
                        useSharedBuffer: audioTweaks.useSharedBuffer,
                        outputQueueMs: audioTweaks.outputQueueMs,
                        crossFadeMs: audioTweaks.crossFadeMs,
                        rampMs: audioTweaks.rampMs,
                    });
                    const initMsg = {
                        type: 'init',
                        debug: debug.enabled || false,
                        namespaces: localStorage.getItem('debug'),
                        audioPort: audioChannel.port2,
                        sampleRate: this.audio.audioContext.sampleRate,
                        outputAudioConfig: 'outputAudioConfig' in wasm ? wasm.outputAudioConfig : {},
                    };
                    const postInitMessage = () => this.worker.postMessage(initMsg, [audioChannel.port2]);
                    if (this.audio.sharedBuffer) {
                        initMsg.sharedBuffer = this.audio.sharedBuffer;
                        initMsg.sharedBufferTimer = audioTweaks.sharedBufferTimer;
                        try {
                            postInitMessage();
                        }
                        catch (_a) {
                            // postMessage may have failed when sending sharedBuffer due to security considerations
                            // (e.g. lack of cross-origin isolation), fallback to implementation without shared buffer
                            delete initMsg.sharedBuffer;
                            this.audio.deleteSharedBuffer();
                            postInitMessage();
                        }
                    }
                    else {
                        postInitMessage();
                    }
                    let inputAudioConfig = 'inputAudioConfig' in wasm ? wasm.inputAudioConfig : { typingNoiseSuppression: true };
                    yield loadPromise;
                    if (!listenOnly) {
                        let inputAudioStartedPromise = this.localMediaStream ? this._startInputAudio(inputAudioConfig) : Promise.resolve(undefined);
                        yield inputAudioStartedPromise;
                    }
                    yield this.audio.startOutputAudio();
                    const fakePeerId = '00000000-0000-0000-0000-000000000000';
                    let peer = {
                        peerId: fakePeerId,
                        connection: null,
                        audioConnection: null,
                        stream: null,
                        process: null,
                        isMaster: null,
                        closed: false,
                    };
                    this.peers.push(peer);
                }
                catch (error) {
                    debug(`Dvwc init failed: reason ${error}`);
                    throw error;
                }
            }
        });
    }
    handleDvwcLog(entry) {
        debug(`Log: ${entry.timestamp.toISOString()} ${entry.level.padStart(10, ' ')} ${entry.component} ${entry.msgId} ${entry.message}\n`);
    }
    onWorkerMessage(msg) {
        switch (msg.type) {
            case 'dvwc-loaded':
                this.initResolve();
                break;
            case 'dvwc-failed':
                this.initReject(msg.reason);
                break;
            case 'packet':
                this.sendPacket(msg.packet);
                break;
            case 'session-stopped':
                this.resolveStopSession();
                break;
            case 'session-stop-rejected':
                this.rejectStopSession(msg.reason);
                break;
            case 'log':
                this.handleDvwcLog(msg.entry);
                break;
            case 'input-level':
                this.onAudioLevel(msg.level);
                break;
            case 'talkers':
                this.onTalkers(msg.levels);
                break;
            case 'status':
                this.onConnectionStatus(msg.status);
                break;
            case 'output-buffer-condition':
                this.onAudioReport(msg);
                break;
            case 'no-op':
                break;
            default:
                const responseMatch = msg.type.match(/(.*)-response/);
                if (responseMatch) {
                    this.workerAsyncCall.handleResponse(responseMatch[1], msg);
                }
        }
    }
    addDataChannelListeners(dataChannel, peerId) {
        dataChannel.onopen = () => this.startDataFlow(dataChannel);
        dataChannel.onclose = () => this.stopDataFlow();
        dataChannel.onerror = function (event) {
            if (!event.error || !event.error.message || event.error.message != 'Transport channel closed') {
                logging_1.default.error('webrtc', 'VoxeetRTCDolbyVoice.dataChannel.onerror', event.error);
                this.emit('error', Exceptions_1.DataChannelError(peerId, event.error ? event.error.message : undefined));
                this.handleUnexpectedLeave();
            }
        }.bind(this);
    }
    addConnectionListeners(peerId) {
        this.onConnectionStatus = function (status) {
            if (status.startsWith('FAILED')) {
                this.emit('error', Exceptions_1.MediaServerConnectionError(peerId));
            }
        }.bind(this);
    }
    addConnectionListeners(peerId) {
        this.onConnectionStatus = function (status) {
            if (status.startsWith('FAILED')) {
                this.emit('error', Exceptions_1.MediaServerConnectionError(peerId));
            }
        }.bind(this);
    }
    addConnectionListeners(peerId) {
        this.onConnectionStatus = function (status) {
            if (status.startsWith('FAILED')) {
                this.emit('error', Exceptions_1.MediaServerConnectionError(peerId));
            }
        }.bind(this);
    }
    addConnectionListeners(peerId) {
        this.onConnectionStatus = function (status) {
            if (status.startsWith('FAILED')) {
                this.emit('error', Exceptions_1.MediaServerConnectionError(peerId));
            }
        }.bind(this);
    }
    startDataFlow(dataChannel) {
        if (!this.haveSession) {
            const msg = { type: 'join' };
            if (typeof this.wasm === 'object' && 'sessionConfig' in this.wasm) {
                msg.sessionConfig = this.wasm.sessionConfig;
            }
            this.worker.postMessage(msg);
            this.haveSession = true;
        }
        dataChannel.onmessage = this.receiveDataChannelPacket.bind(this);
    }
    sendPacket(data) {
        //let data_print = new Uint8Array(data);
        //console.log("send: " + data_print[12])
        this.dataChannel.send(data);
    }
    stopDataFlow() {
        try {
            if (this.dataChannel) {
                let dataChannel = this.dataChannel;
                this.dataChannel = null;
                dataChannel.close();
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    receiveDataChannelPacket(packet) {
        let data = packet.data;
        this.worker.postMessage({ type: 'packet', packet: data }, [data]);
    }
    //Should call per-client mute (stopAudio) on DVWC
    mutePeer(peerId, isMuted) {
        this.peers
            .filter((c) => c.peerId === peerId)
            .map((c) => {
            if (c.isMaster) {
                if (this.haveSession) {
                    this.dvcAudioMuted = isMuted;
                    this.worker.postMessage({ type: 'input-mute', mute: this.dvcAudioMuted });
                }
                else {
                    if (this.audioTrack) {
                        this.audioTrack.enabled = !isMuted;
                    }
                }
            }
            else {
                if (c.process) {
                    c.process.mute(isMuted);
                }
                if (this.audioTags) {
                    this.audioTags.muteAudioTag(peerId, isMuted);
                }
            }
        });
    }
    //Should call per-client mute (stopAudio) on DVWC
    toggleMute(peerId) {
        let muted = false;
        this.peers
            .filter((c) => c.peerId === peerId)
            .map((c) => {
            if (c.isMaster) {
                muted = this.toggleOwnMute();
            }
            else {
                if (c.process) {
                    muted = c.process.toggleMute();
                }
                if (this.audioTags) {
                    const nodeMute = this.audioTags.toggleMute(peerId);
                    if (!this.audio3D) {
                        muted = nodeMute;
                    }
                }
            }
        });
        return muted;
    }
    isOwnMuted() {
        if (this.haveSession) {
            return this.dvcAudioMuted;
        }
        else {
            return !this.audioTrack.enabled;
        }
    }
    toggleOwnMute() {
        if (this.haveSession) {
            this.dvcAudioMuted = !this.dvcAudioMuted;
            this.worker.postMessage({ type: 'input-mute', mute: this.dvcAudioMuted });
            return this.dvcAudioMuted;
        }
        else {
            this.audioTrack.enabled = !this.audioTrack.enabled;
            return !this.audioTrack.enabled;
        }
    }
    //TODO: Implement when spatial placement is done
    setGain(peerId, gain) {
        throw new UnsupportedError();
    }
    db2vu(decibels) {
        const dbrange = 100;
        const dblimit = -100;
        if (decibels === -Infinity || decibels < dblimit)
            return 0;
        if (decibels >= dbrange + dblimit)
            return 1;
        //Normalize value to be in between 0 and 1;
        let normDB = decibels / dbrange;
        let scaled = Math.PI / 2 + (Math.PI / 2) * normDB;
        //Apply scale
        let normalized = 1 - Math.cos(scaled);
        return normalized > 1 ? 1 : normalized;
    }
    getLevel(peerId, callback) {
        if (!this.worker) {
            callback(0);
        }
        let peer = this.peers.find((p) => p.peerId === peerId);
        // TODO: using isMaster to detect if peerId is for current user, refactor for clarity
        if (peer && peer.isMaster) {
            this.audioLevelCallback = (dbLevel) => {
                const level = this.db2vu(dbLevel);
                callback(level);
            };
            this.worker.postMessage({ type: 'get-input-level' });
        }
        else {
            if (this.cachedLevels) {
                callback(this.cachedLevels.get(peerId) || 0);
            }
            else {
                if (!this.pendingLevelCallbacks) {
                    this.pendingLevelCallbacks = new Map();
                    this.worker.postMessage({ type: 'get-talkers' });
                }
                let callbacks = this.pendingLevelCallbacks.get(peerId);
                if (callbacks) {
                    callbacks.push(callback);
                }
                else {
                    this.pendingLevelCallbacks.set(peerId, [callback]);
                }
            }
        }
    }
    onAudioLevel(level) {
        if (this.audioLevelCallback) {
            const callback = this.audioLevelCallback;
            this.audioLevelCallback = null;
            callback(level);
        }
    }
    onTalkers(talkingLevels) {
        this.cachedLevels = new Map();
        for (const talkingLevel of talkingLevels) {
            // IDs from DVWC have the format <guid1>@<guid2>, where <guid1> is peer ID
            const id = talkingLevel.id.split('@')[0];
            const level = talkingLevel.level;
            this.cachedLevels.set(id, level);
        }
        for (const [peerId, callbacks] of this.pendingLevelCallbacks) {
            const level = this.cachedLevels.get(peerId) || 0;
            for (const callback of callbacks) {
                try {
                    callback(level);
                }
                catch (_a) { }
            }
        }
        this.pendingLevelCallbacks = null;
        const cacheTimeout = 100; // ms
        setTimeout(() => (this.cachedLevels = null), cacheTimeout);
    }
    //TODO: Own implementation based on WASM AudioLevel
    isSpeaking(peerId, callback) {
        this.getLevel(peerId, (level) => {
            if (level > this.speechThreshold) {
                callback(true);
            }
            else {
                callback(false);
            }
        });
    }
    onAudioReport(report) {
        if (this.audio) {
            this.audio.collectAudioReport(report);
        }
    }
    //TODO: Refactor to use parts of logic from VoxeetRTCNative
    stopAudioForPeer(peerId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (c.stream && c.isMaster) {
                    if (!this.localMediaStream || this.localMediaStream.getAudioTracks().length === 0) {
                        throw new Exceptions_1.MediaError('Already stopped');
                    }
                    let track = this.audioTrack;
                    track.stop();
                    if (this.audio) {
                        this.audio.stopInputAudio();
                    }
                    if (this.worker) {
                        this.worker.postMessage({ type: 'stop-input-audio' });
                    }
                    this.localMediaStream.removeTrack(track);
                    if (!this.localMediaStream.getTracks().length) {
                        this.removeStreamEvent(peerId, this.localMediaStream);
                        this.localMediaStream = null;
                    }
                    else {
                        this.updateStreamEvent(peerId, this.localMediaStream);
                    }
                }
            })));
        });
    }
    //TODO: Refactor to use parts of logic from VoxeetRTCNative
    startAudioForPeer(peerId, constraints = config_1.default.media.constraints.audio) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.peerId === peerId)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (c.isMaster) {
                    if (this.localMediaStream && this.localMediaStream.getAudioTracks().length > 0) {
                        throw new Exceptions_1.MediaError('Already started');
                    }
                    // Checking constraints
                    this.constraints.audio = constraints;
                    let newConstraints = JSON.parse(JSON.stringify(this.constraints));
                    newConstraints.video = false;
                    try {
                        const stream = yield navigator.mediaDevices.getUserMedia(newConstraints);
                        this.audioTrack = stream.getAudioTracks()[0];
                        if (this.localMediaStream) {
                            // Adding stream to the localmedistream has the addTrack shim don't do it
                            this.localMediaStream.addTrack(this.audioTrack);
                            if (this.worker) {
                                if (this.audio) {
                                    this._startInputAudio();
                                }
                            }
                            else {
                                // TODO: Check if I need this?
                                yield this.addTrack(this.audioTrack, c.audioConnection, this.localMediaStream, 'audio');
                            }
                            this.updateStreamEvent(peerId, this.localMediaStream);
                        }
                        else {
                            this.localMediaStream = stream;
                            this.localMediaStream.type = MediaStream_1.MediaStreamType.Camera;
                            c.stream = stream;
                            if (this.worker) {
                                if (this.audio) {
                                    this._startInputAudio();
                                }
                            }
                            yield this.addStream(this.localMediaStream, c.audioConnection);
                            this.addStreamEvent(peerId, this.localMediaStream);
                        }
                    }
                    catch (err) {
                        throw new Exceptions_1.MediaStreamError(err);
                    }
                }
            })));
        });
    }
    //TODO: Refactor to use parts of logic from VoxeetRTCNative
    selectAudioInput(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.peers
                .filter((c) => c.isMaster === true)
                .map((c) => __awaiter(this, void 0, void 0, function* () {
                if (typeof this.constraints.audio !== 'object') {
                    this.constraints.audio = {};
                }
                let newConstraints = JSON.parse(JSON.stringify(this.constraints));
                newConstraints.audio.deviceId = { exact: deviceId };
                newConstraints.video = false; // Just looking for audio
                const enabled = this.audioTrack.enabled;
                this.audioTrack.stop();
                if (this.audio) {
                    this.audio.stopInputAudio();
                }
                try {
                    const stream = yield navigator.mediaDevices.getUserMedia(newConstraints);
                    this.localMediaStream.removeTrack(this.localMediaStream.getAudioTracks()[0]);
                    this.audioTrack = stream.getAudioTracks()[0];
                    this.audioTrack.enabled = enabled;
                    this.localMediaStream.addTrack(this.audioTrack);
                    if (this.audio) {
                        yield this.audio.startInputAudio(this.localMediaStream);
                    }
                    this.worker.postMessage({ type: 'restart-input-audio' });
                    this.updateStreamEvent(c.peerId, c.stream);
                }
                catch (error) {
                    throw error;
                }
            })));
        });
    }
    selectAudioOutput(deviceId) {
        if (deviceId && this.audioTags) {
            this.audioTags.setSinkId(deviceId);
            this.worker.postMessage({ type: 'restart-output-audio' });
            return Promise.resolve();
        }
        return Promise.reject(new Error('Unavailable'));
    }
    //TODO: Refactor to use parts of logic from VoxeetRTCNative
    getRtpStats() {
        return __awaiter(this, void 0, void 0, function* () {
            const peer = this.peers.find((p) => p.isMaster);
            const stats = yield this.getRtpStatsForTelemetry();
            if (peer) {
                const candidatePair = stats.get(peer.peerId).filter((s) => s.type === 'candidate-pair');
                const dvcStats = stats.get(peer.peerId).filter((s) => s.id === 'DvcStats');
                for (const [peerId, stat] of stats) {
                    let aScore = 0;
                    let vScore = 0;
                    if (peerId === peer.peerId) {
                        // Master / Sender
                        const remoteInboundAudioRtp = stat.filter((s) => (s.type === 'remote-inbound-rtp' || s.type === 'inbound-rtp') && s.kind === 'audio');
                        const outboundAudioRtp = stat.filter((s) => s.type === 'outbound-rtp' && s.kind === 'audio');
                        let lastOutboundAudioRtp = [];
                        if (this.lastStats[peerId]) {
                            lastOutboundAudioRtp = this.lastStats[peerId].filter((s) => s.type === 'outbound-rtp' && s.kind === 'audio');
                        }
                        if (dvcStats.length > 0) {
                            const fractionLost = parseFloat(dvcStats[0].uplinkPacketLossCount) / parseFloat(dvcStats[0].uplinkPacketCount);
                            aScore = WebRtcUtils_1.audioScore(parseFloat(fractionLost * 100), parseFloat(dvcStats[0].roundTripTime), parseFloat(dvcStats[0].uplinkJitter));
                        }
                        else if (remoteInboundAudioRtp.length > 0 &&
                            outboundAudioRtp.length > 0 &&
                            lastOutboundAudioRtp.length > 0 &&
                            outboundAudioRtp[0].bytesSent > lastOutboundAudioRtp[0].bytesSent) {
                            let rtt = candidatePair[0].currentRoundTripTime ? candidatePair[0].currentRoundTripTime : remoteInboundAudioRtp[0].roundTripTime;
                            // Workaround for Firefox: Sometimes remoteInboundAudioRtp[0].roundTripTime is missing in stats
                            rtt = rtt ? rtt : this.recentlySeenRTT;
                            this.recentlySeenRTT = rtt;
                            const fractionLost = parseFloat(remoteInboundAudioRtp[0].packetsLost) / parseFloat(outboundAudioRtp[0].packetsSent);
                            aScore = WebRtcUtils_1.audioScore(parseFloat(fractionLost * 100), parseFloat(rtt) * 1000, parseFloat(remoteInboundAudioRtp[0].jitter) * 1000);
                        }
                        if (this.localMediaStream) {
                            let videoTracks = this.localMediaStream.getVideoTracks();
                            vScore = WebRtcUtils_1.senderVideoScore(this.lastStats[peerId], stat, videoTracks);
                        }
                    }
                    else {
                        // Receivers
                        const inboundAudioRtp = stat.filter((s) => s.type === 'inbound-rtp' && s.kind === 'audio');
                        if (dvcStats.length > 0) {
                            const fractionLost = parseFloat(dvcStats[0].downlinkPacketLossCount) / parseFloat(dvcStats[0].downlinkPacketCount);
                            aScore = WebRtcUtils_1.audioScore(parseFloat(fractionLost * 100), parseFloat(dvcStats[0].roundTripTime), parseFloat(dvcStats[0].downlinkJitter));
                        }
                        else if (inboundAudioRtp.length > 0 && candidatePair.length > 0) {
                            const fractionLost = parseFloat(inboundAudioRtp[0].packetsLost) / parseFloat(inboundAudioRtp[0].packetsReceived);
                            aScore = WebRtcUtils_1.audioScore(parseFloat(fractionLost * 100), parseFloat(candidatePair[0].currentRoundTripTime) * 1000, parseFloat(inboundAudioRtp[0].jitter) * 1000);
                        }
                        const dvcs = this.peers.findIndex((peer) => peer.peerId === '00000000-0000-0000-0000-000000000000') > -1;
                        vScore = WebRtcUtils_1.videoScore(this.lastStats[peerId], stat, dvcs);
                    }
                    this.lastStats[peerId] = [...stat];
                    stats.set(peerId, [...stat, { id: 'Scores', audio: aScore, video: vScore }]);
                }
            }
            return stats;
        });
    }
    getDvcStats() {
        return this.workerAsyncCall.request('stats');
    }
    //TODO: Refactor to use parts of logic from VoxeetRTCNative
    getRtpStatsForTelemetry() {
        return __awaiter(this, void 0, void 0, function* () {
            const peer = this.peers.find((p) => p.isMaster);
            let result = new Map();
            if (peer) {
                let stats = yield peer.connection.getStats(null);
                let datachannel_stats = yield peer.audioConnection.getStats(null);
                stats = [...stats.values()];
                datachannel_stats = [...datachannel_stats.values()];
                // Peer outbound stats, affected to Master
                const outboundStats = [];
                stats
                    .filter((s) => s.type === 'media-source' ||
                    s.type === 'outbound-rtp' ||
                    (s.type === 'remote-inbound-rtp' && s.localId) ||
                    s.type === 'candidate-pair' ||
                    s.type === 'inbound-rtp' ||
                    (s.type === 'track' && s.remoteSource === false)) // Filter remote outbound that are not associated with a localId
                    .forEach((s) => {
                    outboundStats.push(s);
                });
                // Add datachannel stats from another peer connection
                datachannel_stats
                    .filter((s) => (s.type === s.type) == 'data-channel' || s.type === 'candidate-pair')
                    .forEach((s) => {
                    outboundStats.push(s);
                });
                // avoid browser differences in field names
                outboundStats.forEach((s) => {
                    if (!s.hasOwnProperty('kind') && s.hasOwnProperty('mediaType')) {
                        s.kind = s.mediaType;
                    }
                });
                result.set(peer.peerId, outboundStats);
                if (browser.isBrowser('chrome', true)) {
                    stats
                        .filter((s) => s.type === 'stream')
                        .forEach((stream) => {
                        // Extracting peerId
                        const re = /([0-9]*)_?([a-zA-Z0-9]*)_?([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})/gm;
                        const matches = re.exec(stream.streamIdentifier);
                        if (matches && matches[3]) {
                            // found peer Id
                            const peerStats = new Array();
                            peerStats.push(stream);
                            stream.trackIds.forEach((trackId) => {
                                // Appending track informations
                                stats.filter((stat) => stat.id == trackId || stat.trackId == trackId).forEach((ts) => peerStats.push(ts));
                            });
                            result.get(matches[3]) && peerStats.push(...result.get(matches[3]));
                            result.set(matches[3], peerStats);
                        }
                        else {
                            logging_1.default.error('webrtc', 'VoxeetRTCNative.getRtpStatsForTelemetry', 'Unable to found peer for stream telemetry');
                        }
                    });
                }
                else {
                    // Inbound stats, based on stream id to associate with a peer Id
                    this.peers.forEach(({ stream, peerId }) => {
                        if (!stream)
                            return;
                        const audioTracks = stream.getAudioTracks();
                        const videoTracks = stream.getVideoTracks();
                        const mergedTracks = [...audioTracks, ...videoTracks];
                        const first = mergedTracks.flatMap((track) => stats.filter((stat) => stat.trackIdentifier === track.id));
                        const second = first.flatMap((filteredStat) => stats.filter((stat) => stat.trackId === filteredStat.id && stat.type === 'inbound-rtp'));
                        const consolidated = [...first, ...second];
                        const peerStats = [];
                        result.get(peerId) && peerStats.push(...result.get(peerId));
                        result.set(peerId, [...consolidated, ...peerStats]);
                    });
                }
                // For cases where DVCS server is used, there is one downlink stream with mixed audio from all
                // participants (as opposed to other solution, where each participant has its own downlink audio stream).
                // For that mixed stream a "fake" peer connection is created to maintain stream activity, track and statistics.
                // For WASM the DVCS downlink mixed audio stream and uplink audio stream are embedded in data channel
                // of current user's peer connection. RTP statistics of these streams come from DVC module.
                // Here, we fill "fake" DVCS peer connection with downlink statistics collected from DVC, and master
                // peer connection with uplink statistics.
                const fakePeerId = '00000000-0000-0000-0000-000000000000';
                result.set(fakePeerId, []);
                if (this.worker) {
                    const dvcStats = yield this.getDvcStats();
                    if (dvcStats) {
                        const outAudioStats = {
                            ssrc: 2,
                            trackId: '',
                            mediaType: 'audio',
                            packetsSent: dvcStats.uplinkPacketCount,
                            bytesSent: dvcStats.uplinkPayloadBytes,
                            retransmittedPacketsSent: 0,
                            retransmittedBytesSent: 0,
                            type: 'outbound-rtp',
                        };
                        const remoteInAudioStats = {
                            ssrc: 2,
                            kind: 'audio',
                            packetLost: dvcStats.uplinkPacketLossCount,
                            jitter: dvcStats.uplinkJitter * 0.001,
                            roundTripTime: dvcStats.roundTripTime,
                            type: 'remote-inbound-rtp',
                        };
                        result.set(peer.peerId, result
                            .get(peer.peerId)
                            .concat(Object.assign({ id: 'DvcStats' }, dvcStats))
                            .concat(Object.assign({ id: 'RTCOutboundRTPAudioStream_2' }, outAudioStats))
                            .concat(Object.assign({ id: 'RTCRemoteInboundRTPAudioStream_2' }, remoteInAudioStats)));
                        const inAudioRtpStats = {
                            audioLevel: dvcStats.outputLevel,
                            bytesReceived: dvcStats.downlinkPayloadBytes,
                            jitter: dvcStats.downlinkJitter * 0.001,
                            mediaType: 'audio',
                            packetsLost: dvcStats.downlinkPacketLossCount,
                            packetsReceived: dvcStats.downlinkPacketCount,
                            ssrc: 2,
                            trackId: 'RTCMediaStreamTrack_receiver_1',
                            transportId: 'RTCTransport_audio_1',
                            type: 'inbound-rtp',
                        };
                        const inTrack = {
                            type: 'track',
                            kind: 'audio',
                            audioLevel: dvcStats.outputLevel,
                        };
                        result.set(fakePeerId, [
                            Object.assign({ id: 'RTCInboundRTPAudioStream_2' }, inAudioRtpStats),
                            Object.assign({ id: 'RTCMediaStreamTrack_receiver_1' }, inTrack),
                        ]);
                    }
                }
                if (this.audio) {
                    const report = this.audio.createAudioReport();
                    const webAudioStats = {
                        type: 'audio',
                        bufferIsOverrun: report.outputBuffer.overrun.have,
                        bufferOverrunTimes: report.outputBuffer.overrun.times,
                        bufferOverrunLength: report.outputBuffer.overrun.longestTicks,
                        bufferIsUnderrun: report.outputBuffer.underrun.have,
                        bufferUnderrunTimes: report.outputBuffer.underrun.times,
                        bufferUnderrunLength: report.outputBuffer.underrun.longestTicks,
                    };
                    result.set(peer.peerId, result.get(peer.peerId).concat(Object.assign({ id: 'WebAudioStats' }, webAudioStats)));
                }
            }
            return result;
        });
    }
    createStateDump(liteMode) {
        return this.workerAsyncCall.request('state-dump', { liteMode });
    }
    configureStateDump(audioLoggingLength) {
        this.worker.postMessage({ type: 'audio-logging-length', length: audioLoggingLength });
    }
    setTransparentMode(transparent) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.workerAsyncCall.request('set-transparent-mode', { transparent });
        });
    }
}
exports.default = VoxeetRTCDolbyVoice;
